{/* Copyright 2026 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License. */}

import {Layout} from '../../../src/Layout';
export default Layout;
import {FunctionAPI} from '../../../src/FunctionAPI';
import {InterfaceType} from '../../../src/types';
import docs from 'docs:@react-aria/button';

export const section = 'Hooks';
export const description = 'Provides the behavior and accessibility implementation for a button.';
export const isSubpage = true;

# useButton

<PageDescription>{docs.exports.useButton.description}</PageDescription>

```tsx render files={["starters/hooks/src/Button.tsx", "starters/hooks/src/Button.css"]}
"use client";
import {Button} from 'hooks-starter/Button';

<Button onPress={() => alert('Button pressed!')}>Press me</Button>
```

## API

<FunctionAPI function={docs.exports.useButton} links={docs.links} />

### AriaButtonProps

<InterfaceType {...docs.exports.AriaButtonProps} />

### ButtonAria

<InterfaceType {...docs.exports.ButtonAria} />
